import { render, staticRenderFns } from "./DefectRuleConfig.vue?vue&type=template&id=771b68a1&scoped=true&"
import script from "./DefectRuleConfig.js?vue&type=script&lang=js&"
export * from "./DefectRuleConfig.js?vue&type=script&lang=js&"
import style0 from "./DefectRuleConfig.vue?vue&type=style&index=0&id=771b68a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b68a1",
  null
  
)

export default component.exports